import { render } from "./PostItems.vue?vue&type=template&id=36e31098&scoped=true"
import script from "./PostItems.vue?vue&type=script&lang=js"
export * from "./PostItems.vue?vue&type=script&lang=js"

import "./PostItems.vue?vue&type=style&index=0&id=36e31098&scoped=true&lang=css"

import exportComponent from "D:\\secret\\py\\main_bot\\bank-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e31098"]])

export default __exports__